/* GENERATED BY `js-common lang`, DO NOT EDIT MANUALLY */
export default {
  getN: (n) => n !== 1,
  messages: {
    _: {
      'Could not load': 'Kunde inte ladda',
      '{{count}} of {{total}}.': '{{count}} av {{total}}.',
      'Gallery with {{count}} images. Navigate with the left and right arrow keys.':
        'Galleri med {{count}} bilder. Navigera med vänster- och högerpil.',
      'Large image.': 'Stor bild.',
    },
    lightbox: {
      Close: 'Stäng',
      Back: 'Bakåt',
      Previous: 'Föregående',
      Next: 'Nästa',
    },
  },
};
